import React from 'react';
import PropTypes from 'prop-types';
import s from '../styles.module.scss';

const PatientEngagementRow = ({ status, module, charter, feedback }) => (
  <tr>
    <td className={s.noWrap}>{status}</td>
    <td>{module}</td>
    <td>{charter}</td>
    <td>{feedback}</td>
  </tr>
);

PatientEngagementRow.defaultProps = {
  feedback: null,
};

PatientEngagementRow.propTypes = {
  status: PropTypes.string.isRequired,
  module: PropTypes.string.isRequired,
  charter: PropTypes.string.isRequired,
  feedback: PropTypes.string,
};

export default PatientEngagementRow;
